(() => {
  const root = document.documentElement;
  root.classList.add('ss77-enhanced');
  const cards = document.querySelectorAll('.ss77-switcher__world, .ss77-editorial__tile');
  cards.forEach((card) => {
    card.addEventListener('pointermove', (event) => {
      const rect = card.getBoundingClientRect();
      card.style.setProperty('--ss77-x', `${((event.clientX - rect.left) / rect.width) * 100}%`);
      card.style.setProperty('--ss77-y', `${((event.clientY - rect.top) / rect.height) * 100}%`);
    }, { passive: true });
  });
})();
